import {FormikProps, FormikHelpers} from 'formik';

import {Props} from './types';

export const addSearchWord = (
  formProps: FormikProps<any>,
  inputFieldName: string,
  searchFieldName: string
) => {
  const inputWord = formProps.values[inputFieldName].trim();

  if (inputWord) {
    const searchWords = formProps.values[searchFieldName];
    // 検索キーワードラベルを追加
    searchWords.push({
      text: inputWord,
      id: searchWords.length,
    });
    formProps.setFieldValue(searchFieldName, searchWords);

    formProps.setFieldValue(inputFieldName, '');
  } else {
    return;
  }
};

export const searchNotifications = async (
  values: any,
  formikHelpers: FormikHelpers<any>,
  props: Props,
  setLoading: React.Dispatch<React.SetStateAction<boolean>>
) => {
  formikHelpers.setSubmitting(true);
  setLoading(true);
  await props.actions.notifications.updateSearchWordsNotifications(
    {
      fromSentDatetime: values.fromSentDatetime,
      toSentDatetime: values.toSentDatetime,
      disasterType: values.disasterType,
      prefecture: values.prefecture,
    },
    props.me.teamId
  );
  setLoading(false);

  formikHelpers.setSubmitting(false);
};

export const updateCurrent = async (
  props: Props,
  current: number,
  setIsPaging: React.Dispatch<React.SetStateAction<boolean>>
) => {
  props.actions.notifications.updateActiveNotifications(
    props.notifications.pagination.data,
    props.notifications.pagination.current,
    current,
    props.notifications.pagination.totalPages
  );
  setIsPaging(true);
  await props.actions.notifications.updateCurrentNotifications({
    page: current,
    sort: props.notifications.pagination.sort,
    teamId: props.me.teamId,
    disasterType: props.notifications.search.disasterType,
    fromSentDatetime: props.notifications.search.fromSentDatetime,
    toSentDatetime: props.notifications.search.toSentDatetime,
    prefecture: props.notifications.search.prefecture,
  });
  setIsPaging(false);
};
